import { appConfig } from "../types/app/appConfig";

const initalAppConfig:appConfig = {
    language: "",
    apiKey: "",
    apiUrl: "",
    availAbleLanguage: [],
    translations: {},
};

export { initalAppConfig };
